export enum RouteName {
  GeneratedReportsList = 'generated-reports-list',
  ReportSchedulerList = 'report-scheduler-list',
  ReportSchedulerDetail = 'report-scheduler-detail',
}
